import AppModl from '@/components/AppModal';
import NationIndexBar from '@/components/NationIndexBar';
import RpIcon from "@/components/RpIcon";
import { INPUT_THROTTLE_MS } from "@/constant/Constant";
import { getNationIcon } from "@/utils/utils";
import { Box, OutlinedInput, Stack, Typography } from '@mui/material';
import { debounce } from "es-toolkit";
import { groupBy } from "es-toolkit/array";
import { filter } from "es-toolkit/compat";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import useSettings from "@/hook/useSettings";
import {useTranslation} from "react-i18next";
import classes from './index.module.css'
const Label = (props: any) => {
  const { nation, isCompact, selected, showAreaCode = true } = props
  return (
    <Stack sx={{width: '100%'}} direction="row" alignItems="center" justifyContent="space-between">
      <Stack direction="row" spacing={1} alignItems="center" >
        {showAreaCode && <Typography sx={{width: '40px'}}>{nation?.areaCode}</Typography>}
        <img
          style={{display: 'block', width: '32px', height: '32px'}}
          src={getNationIcon(nation)} />
        <Typography>{nation.name}</Typography>
      </Stack>
      {selected?.code3 == nation.code3 && <Stack>
        <RpIcon icon="check-circle-full" size={24} />
      </Stack>}
    </Stack>
  )

}

const NationSelectModal = (props) => {
  const { open, onClose, onSelect, isCompact, selected, showAreaCode, isBindMobile, isBillingAddress, isShippingAddress } = props;
  const {countries, locationInfo} = useSelector((state) => state.app);
  const [searchWord, setSearchWord] = useState('');

  const { settings } = useSettings()
  const { t } = useTranslation();

  const dataSource = useMemo(() => {
    if (!countries) return [];
    let _countries = []
    let __countries = []

    if (isBindMobile) {
      __countries = countries.filter(_ => {
        return _.isSupportKyc == 1
      })
    } else if (isBillingAddress) {
      __countries = countries.filter(_ => {
        return _.isSupportBilling == 1
      })
    } else if (isShippingAddress) {
      __countries = countries.filter(_ => {
        return _.isSupportShipping == 1
      })
    } else {
      __countries = countries
    }
    if  (searchWord !== '') {
      _countries = filter(__countries, (_) => {
        return _.areaCode.includes(searchWord.toLowerCase())
          || _.code.toLowerCase().includes(searchWord.toLowerCase())
          || _.code3.toLowerCase().includes(searchWord.toLowerCase())
          || _.name.toLowerCase().includes(searchWord.toLowerCase())
          || _.enName.toLowerCase().includes(searchWord.toLowerCase())
          ;
      })
    } else {
      _countries = __countries
    }

    const grouped = groupBy(_countries, (_) => {
      return _.enName.slice(0, 1)
    })
    const _dataSource = Object.keys(grouped).map(key => {
      return {
        title: key,
        children: grouped[key].map(_ => {
          return {
            label: <Label showAreaCode={showAreaCode} selected={selected} isCompact={isCompact} nation={_} />,///_.enName,
            value: _
          }
        })
      }
    }).sort((a, b) => a.title.localeCompare(b.title));
    return _dataSource
  }, [countries, searchWord])

  useEffect(() => {
    if (selected) {
      setSearchWord(selected.areaCode);
    }
  }, [selected]);

  const _onSelect = (item) => {
    onSelect && onSelect(item);
    onClose && onClose()
  }

  const _onChange = (e) => {
    // console.log("监听输入值",e.target.value)
    setSearchWord(e.target.value)
  }
  const _debounceOnChange = useCallback(debounce(_onChange, INPUT_THROTTLE_MS), [_onChange]);

  const nationIndexBarClass = useMemo(() => {
    let ret = settings.lang == 'ar' ? classes.nationIndexBarAr : ''
    return ret
  }, [settings.lang]);

  return (<>
    <AppModl
      open={open}
      onClose={() => {
        setSearchWord('')
        onClose && onClose()
      }}
    >
      <Stack
        sx={{height: '44px', padding: '0 16px'}}
        direction="row" alignItems="center" justifyContent="space-between">
        <RpIcon
          clickable
          icon="arrow-left"
          onClick={() => {
            onClose && onClose()
          }}
        />
        <Typography sx={{flex: 1, textAlign: 'center'}}>{t('select_country')}</Typography>
      </Stack>
      <Stack sx={{height: 'auto'}}>
        <Stack sx={{padding: '16px'}}>
          <OutlinedInput
            // value={searchWord}
            onChange={_onChange}
            startAdornment={
              <Box sx={{marginRight: '6px'}}>
                <RpIcon icon="search" />
              </Box>
            }
          />
        </Stack>
        <Stack sx={{
          height: '500px',
        }}
               className={ nationIndexBarClass}
        >
          <NationIndexBar
            showAreaCode={showAreaCode} selected={selected} dataSource={dataSource} onSelect={_onSelect} />
        </Stack>
      </Stack>
    </AppModl>
  </>)
}

export default NationSelectModal